import { SxProps } from '@mui/system';

export const MainBox: SxProps = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '5px',
};
